/**
 * Setup: add the below script to the theme.liquid file to run on every page load
 *
 * <script src="//www.ever.com/cdn/shop/t/279/assets/skio-discount-tiers.js?v=156401029723313972661778516071" defer="defer"></script>
 *
 * Make sure the selector below covers all checkout buttons
 */

// scope variables
(() => {
  const checkoutHandler = async (event) => {
    // console.log("SKIO CHECKOUT HANDLER");

    const codes = [
      {
        'code': 'SUBSCRIBETOSAVE10',
        'tags': [
          'Active product subscription'
        ]
      },
      {
        'code': 'AMBASSADOR-25%',
        'tags': [
          'Ambassador',
          '4232',
          '5020'
        ]
      },
      {
        'code': 'STAR-25%',
        'tags': [
          'star ambassador',
          '5052',
          '3402'
        ]
      },
      {
        'code': 'SPECIALIST-35%',
        'tags': [
          'Specialist',
          '4230',
          '5054'
        ]
      }
    ]
    let current_code = 'SUBSCRIBETOSAVE10';

    let customer_tags_el = document.querySelector("#customer-tags");
    let customer_tags = JSON.parse(customer_tags_el.textContent);
    // console.log("SKIO CHECK customer tags: ", customer_tags);     

    codes.forEach((code) => {
      let code_tags = code['tags'];
      code_tags.forEach((tag) => {
        customer_tags.forEach((c_tag) => {
          if (tag == c_tag) current_code = code['code'];
        });
      });
    });

    // Apply code
    if (current_code) await fetch(`/discount/${encodeURIComponent(current_code)}`)

    window.skio_ran_tier_discount = true
  }

  document.addEventListener('DOMContentLoaded', checkoutHandler)
})()